<template>
    <f7-page class="homepage" name="index">
      <bc-navbar></bc-navbar>   
      <varius-component :style="{ 'overflow': isAddToHSShowedFlag === true ? 'hidden':'auto'  }"></varius-component>
    </f7-page>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import VariustTemplate from "../../components/home-page-components/varius-component"

export default {
  name:'home-page',
  components: {
    "varius-component":VariustTemplate    
  },
  computed: {
    ...mapState({    
      isAddToHSShowedFlag: state => state.standalone.isAddToHShowed,
      customization:state=>state.common.customization
    }) 
  } 
}
</script>




// WEBPACK FOOTER //
// index.page.vue?1cc43934